import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { IGetServiceProps } from "@api/types/globalService.types";

export const useGetAllPartnerLandingPageService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allPartnerLandingPageService = useQuery({
    queryKey: [...CACHE_KEYS.LANDING_PAGES, page, per_page, debouncedQuery],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.PARTNER_LANDING_PAGE,
        searchParams: {
          "filter[name]": debouncedQuery,
          page: page,
          per_page: per_page,
          include: "partner,journeys,journeys.segment,journey_type",
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allPartnerLandingPageService },
    states: { searchQuery, setSearchQuery },
  };
};
